var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.718 7.705c-1.19-.999-2.575-1.74-4.066-2.18a12.055 12.055 0 0 0-4.209-.503c-.61.031-1.22.097-1.823.198-1.28.23-2.511.677-3.642 1.32a9.966 9.966 0 0 0-3.713 3.497 8.09 8.09 0 0 0-1.021 6.316 8.77 8.77 0 0 0 2.836 4.593 11.493 11.493 0 0 0 6.263 2.772 1.006 1.006 0 0 1 .907.716c.04.131.051.27.035.406 0 .36-.082.72-.126 1.078a2.102 2.102 0 0 0-.044.816.28.28 0 0 0 .315.264c.226-.03.448-.087.66-.172.94-.435 1.83-.967 2.658-1.588a43.966 43.966 0 0 0 5.19-4.3 11.481 11.481 0 0 0 1.522-1.708A8.402 8.402 0 0 0 27 14.446a8.24 8.24 0 0 0-.31-2.25 9.087 9.087 0 0 0-2.972-4.49z",
    fill: "#000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/Chat.b23b63a37ed667417483b75d1e9c3593.svg";
export { ForwardRef as ReactComponent };